<template>
  <div class="card-container" style="background: #f0f2f5">
    <!-- <div class="card-container" style="background: #ffffff"> -->
    <div class="path-container" style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>超级智能体工作站</el-breadcrumb-item>
        <el-breadcrumb-item>高血压智能体</el-breadcrumb-item>
        <el-breadcrumb-item>临床营养</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div style="margin-bottom: 1vh; padding: 0px 0px; border-radius: 4px">
      <el-breadcrumb separator="/">
        <!-- <el-breadcrumb-item :to="{ path: '/index' }">&lt;</el-breadcrumb-item> -->
        <i class="el-icon-back" style="font-size: 20px; font-weight: bolder" @click="back()"></i>
      </el-breadcrumb>
    </div>

    <el-button-group>
      <el-button class="healthButton" @click="click(0)">数字档案</el-button>
      <el-button class="healthButton" @click="click(2)">血压统计数据</el-button>
      <el-button class="healthButton" @click="click(3)">运动处方</el-button>
      <el-button class="healthButton healthActive" @click="click(1)">营养处方</el-button>
      <el-button class="healthButton" @click="click(4)">行为认知治疗</el-button>
      <el-button class="healthButton" @click="click(6)">药物方案</el-button>
      <el-button class="healthButton" @click="click(5)">运动随访</el-button>
    </el-button-group>

    <div class="card">
      <div class="left">
        <div class="person">
          <div class="title"></div>
          <div class="img">
            <div><img src="@/page/login/images/personal.png" /></div>
          </div>
          <div class="name">{{ info.name }}</div>
          <div class="body">
            <div class="th">
              <div class="td">性别：</div>
              <div class="tr">{{ info.sex === 1 ? '男' : info.sex === 2 ? '女' : '未填写' }}</div>
            </div>
            <div class="th">
              <div class="td">手 机 号 码：</div>
              <div class="tr">{{ info.mobile }}</div>
            </div>
            <div class="th">
              <div class="td">身高 | 体重：</div>
              <div class="tr">{{ info.height ? info.height : ' ' }}cm | {{ info.weight ? info.weight : ' ' }}kg</div>
            </div>
            <div class="th">
              <div class="td">年龄 | 生日：</div>
              <div class="tr">{{ info.age }}岁 | 未填写</div>
            </div>
            <div class="th">
              <div class="td">生 成 时 间：</div>
              <div class="tr">{{ schemeNutrition.reportTime ? schemeNutrition.reportTime : '用户未生成本周临床营养指导' }}</div>
            </div>
            <div class="th">
              <div class="td">身 份 证 号：</div>
              <div class="tr">{{ info.idCard }}</div>
            </div>
          </div>
        </div>

        <div class="plan">
          <div class="title">
            <img src="@/page/login/images/plan.png" />
            <div>营养方案总原则</div>
          </div>
          <div class="body">
            <div v-for="(item, index) in schemeNutrition.principles" :key="index">
              {{ item }}
            </div>
            <!-- <div>1、低胆固醇饮食，控制饱和脂肪摄入，改善血脂异常；</div>
            <div>2、限盐（每日钠摄入＜2000mg），保护肾脏功能，预防高血压进展</div>
            <div>3、适量优质蛋白摄入，减轻肾脏负担，避免高蛋白加重肾损伤</div>
            <div>4、增加膳食纤维和钾摄入，帮助调节血脂、促进肠道健康、对抗骨质疏松</div>
            <div>5、禁酒，减少肝脏代谢负担，延缓非酒精性脂肪肝进展</div>
            <div>6、控制总热量，维持健康体重，改善脂肪肝和代谢紊乱</div>
            <div>7、避免高嘌呤食物，预防尿酸升高及泌尿系结石复发</div> -->
          </div>
        </div>
      </div>

      <div class="right">
        <div class="chuF">
          <div class="title">
            <div :class="chuFshow == 1 ? 'active' : ''" @click="changeChuF(1)">膳食处方</div>
            <div :class="chuFshow == 2 ? 'active' : ''" @click="changeChuF(2)">营养素配方</div>
          </div>
          <template v-if="chuFshow == 1">
            <div class="content">
              <div class="name">
                <div class="icon h1"></div>
                <div class="dt">标准体重计算与评估</div>
              </div>
              <div class="card">
                标准体重: {{ schemeNutrition.schemeNutritionNew.standardWeight || '' }}
                <br />
                体质指数：{{ schemeNutrition.schemeNutritionNew.bmi || '' }}
                <br />
                评估：{{ schemeNutrition.schemeNutritionNew.evaluate || '' }}
              </div>
            </div>
            <div class="content">
              <div class="name">
                <div class="icon h2"></div>
                <div class="dt">每日总热量需求</div>
              </div>
              <div class="card">
                身体情况：{{ schemeNutrition.schemeNutritionNew.bodyDetails || '' }}
                <br />
                所需热量摄入：{{ schemeNutrition.schemeNutritionNew.requiredHeat ? '按基础代谢+轻度活动估算，约' + schemeNutrition.schemeNutritionNew.requiredHeat + 'kcal/日' : '' }}
                <br />
                建议热量摄入：{{ schemeNutrition.schemeNutritionNew.suggestedHeat ? schemeNutrition.schemeNutritionNew.suggestedHeat + 'kcal/日' : '' }}
                <!-- 身体详情：青年男性，轻体力活动，存在非酒精性脂肪性肝病、高胆固醇血症、肾功能障碍、骨质疏松、泌尿系结石 所需热量摄入：按基础代谢+轻度活动估算，约2200-2400kcal/日
                建议热量摄入：2000kcal/日（适度能量负平衡，促进脂肪肝改善，同时不加重肾负担） -->
              </div>
            </div>
            <div class="content">
              <div class="name">
                <div class="icon h3"></div>
                <div class="dt">主食</div>
              </div>
              <div class="card">
                摄入：{{ schemeNutrition.schemeNutritionNew.stapleFoodIntake || '' }}
                {{ schemeNutrition.schemeNutritionNew.stapleFoodAttention ? ' （注意： ' + schemeNutrition.schemeNutritionNew.stapleFoodAttention + '）' : '' }}
                <!-- 摄入：每日250g（生重），以复合碳水为主，如糙米、燕麦、全麦面包、藜麦、红薯等 注意：避免精制糖和高升糖指数食物（如白面包、糕点、含糖饮料），防止胰岛素抵抗和脂肪堆积 -->
              </div>
            </div>
            <div class="content">
              <div class="name">
                <div class="icon h4"></div>
                <div class="dt">蔬菜</div>
              </div>
              <div class="card">
                摄入：{{ schemeNutrition.schemeNutritionNew.vegetableIntake || '' }}
                {{ schemeNutrition.schemeNutritionNew.vegetableAttention ? ' （注意： ' + schemeNutrition.schemeNutritionNew.vegetableAttention + '）' : '' }}
                <!-- 摄入：每日500g以上，深色蔬菜占一半以上（如菠菜、西兰花、空心菜、番茄、紫甘蓝） 注意：优先选择低草酸蔬菜（焯水后食用菠菜、苋菜），减少泌尿系结石风险；保证钾摄入以对抗骨质疏松 -->
              </div>
            </div>
            <div class="content">
              <div class="name">
                <div class="icon h5"></div>
                <div class="dt">水果</div>
              </div>
              <div class="card">
                摄入：{{ schemeNutrition.schemeNutritionNew.fruitIntake || '' }}
                {{ schemeNutrition.schemeNutritionNew.fruitAttention ? ' （注意： ' + schemeNutrition.schemeNutritionNew.fruitAttention + '）' : '' }}
                <!-- 摄入：每日200g以内，选择低糖高纤维水果（如苹果、梨、柚子、草莓、蓝莓）
                注意：避免高糖水果（如荔枝、芒果、葡萄）；分次食用，避免一次性血糖波动；肾功能受损者避免过量钾摄入（本例尚可耐受适量钾） -->
              </div>
            </div>
            <div class="content">
              <div class="name">
                <div class="icon h1"></div>
                <div class="dt">蛋白质类食物</div>
              </div>
              <div class="card">
                肉类/禽类：{{ schemeNutrition.schemeNutritionNew.proteinMeatOrPoultry || '' }}
                <br />
                鱼虾类：{{ schemeNutrition.schemeNutritionNew.proteinSeafood || '' }}
                <br />
                蛋类：{{ schemeNutrition.schemeNutritionNew.proteinEggs || '' }}
                <br />
                奶类及豆制品：{{ schemeNutrition.schemeNutritionNew.proteinDairyProductsOrBeans || '' }}
                <!-- 肉类/禽类：每日瘦肉不超过100g，优选鸡胸肉、去皮鸭肉，避免肥肉、动物内脏（高胆固醇） 鱼虾类：每周至少3次，每次80-100g，优选深海鱼（三文鱼、鲭鱼、带鱼）富含ω-3脂肪酸，调节血脂
                蛋类：每日不超过半个蛋黄，可吃1个蛋白（鸡蛋或鹌鹑蛋），避免高胆固醇
                奶类及豆制品：每日牛奶200ml（低脂或脱脂），豆腐50-100g；慎用大豆蛋白粉，避免加重肾负担；忌用高盐豆制品（如咸菜、腐乳） -->
              </div>
            </div>
          </template>
          <template v-else>
            <div class="content">
              <div class="name">
                <div class="icon h1"></div>
                <div class="dt">碳水化合物</div>
              </div>
              <div class="card">
                <!-- 占比：50%； 摄入量：250g（提供1000kcal）； 来源：全谷物、杂粮、薯类、低糖水果 -->
                占比：{{ schemeNutrition.schemeNutritionNew.carbohydrateProportion || '' }}
                {{ schemeNutrition.schemeNutritionNew.carbohydrateIntake ? '摄入量：' + schemeNutrition.schemeNutritionNew.carbohydrateIntake + '；' : '' }}
                {{ schemeNutrition.schemeNutritionNew.carbohydrateSource ? '来源：' + schemeNutrition.schemeNutritionNew.carbohydrateSource + '。' : '' }}
              </div>
            </div>
            <div class="content">
              <div class="name">
                <div class="icon h2"></div>
                <div class="dt">蛋白质</div>
              </div>
              <div class="card">
                占比：{{ schemeNutrition.schemeNutritionNew.proteinProportion || '' }}
                {{ schemeNutrition.schemeNutritionNew.proteinIntake ? '摄入量：' + schemeNutrition.schemeNutritionNew.proteinIntake + '；' : '' }}
                {{ schemeNutrition.schemeNutritionNew.proteinSource ? '来源：' + schemeNutrition.schemeNutritionNew.proteinSource + '。' : '' }}
                <!-- 占比：15%；摄入量：75g（按1.0g/kg/d计算，兼顾肾功能限制）；来源：鱼类、禽类、蛋清、低脂奶、豆腐（优质蛋白为主） -->
              </div>
            </div>
            <div class="content">
              <div class="name">
                <div class="icon h3"></div>
                <div class="dt">脂肪</div>
              </div>
              <div class="card">
                占比：{{ schemeNutrition.schemeNutritionNew.fatProportion || '' }}
                {{ schemeNutrition.schemeNutritionNew.fatIntake ? '摄入量：' + schemeNutrition.schemeNutritionNew.fatIntake + '；' : '' }}
                {{ schemeNutrition.schemeNutritionNew.fatSource ? '来源：' + schemeNutrition.schemeNutritionNew.fatSource + '。' : '' }}
                <!-- 占比：35%； 摄入量：78g； 来源：植物油（橄榄油、菜籽油为主，每日25g）、坚果（每日10g核桃或杏仁）、鱼油、避免动物油、奶油、反式脂肪 -->
              </div>
            </div>
            <div class="content">
              <div class="name">
                <div class="icon h4"></div>
                <div class="dt">膳食纤维</div>
              </div>
              <div class="card">
                {{ schemeNutrition.schemeNutritionNew.dietaryFiberIntake ? '摄入量：' + schemeNutrition.schemeNutritionNew.dietaryFiberIntake + '；' : '' }}
                {{ schemeNutrition.schemeNutritionNew.dietaryFiberSource ? '来源：' + schemeNutrition.schemeNutritionNew.dietaryFiberSource + '。' : '' }}
                <!-- 膳食纤维； 摄入量：30g/日； 来源：全谷物、豆类、蔬菜、水果、菌菇 -->
              </div>
            </div>
            <div class="content">
              <div class="name">
                <div class="icon h5"></div>
                <div class="dt">钾</div>
              </div>
              <div class="card">
                {{ schemeNutrition.schemeNutritionNew.potassiumIntake ? '摄入量：' + schemeNutrition.schemeNutritionNew.potassiumIntake + '；' : '' }}
                {{ schemeNutrition.schemeNutritionNew.potassiumSource ? '来源：' + schemeNutrition.schemeNutritionNew.potassiumSource + '。' : '' }}
                <!-- 摄入量：3000mg/日（未达肾衰阶段，可适当补充）； 来源：香蕉（半根/日）、土豆、番茄、菠菜、木耳、橙子、西兰花 -->
              </div>
            </div>
          </template>
        </div>
        <div class="week">
          <div class="side">一周营养方案</div>
          <div class="content">
            <div class="title">
              <div :class="weekTap == '日' ? 'active' : ''" @click="weekChange('日')">周日</div>
              <div :class="weekTap == '一' ? 'active' : ''" @click="weekChange('一')">周一</div>
              <div :class="weekTap == '二' ? 'active' : ''" @click="weekChange('二')">周二</div>
              <div :class="weekTap == '三' ? 'active' : ''" @click="weekChange('三')">周三</div>
              <div :class="weekTap == '四' ? 'active' : ''" @click="weekChange('四')">周四</div>
              <div :class="weekTap == '五' ? 'active' : ''" @click="weekChange('五')">周五</div>
              <div :class="weekTap == '六' ? 'active' : ''" @click="weekChange('六')">周六</div>
            </div>
            <div class="tent">
              <div class="food" v-for="item in foodInfo" :key="item.name">
                <div>{{ item.name }}</div>
                <div>{{ item.value }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
import { getSchemeNutritionNew, getUserJkDetail } from '@/api/health/manage'
import func from '@/util/func'

export default {
  name: 'ThreeCardLayout',
  data() {
    return {
      wxUserId: this.$route.query.wxUserId,
      info: {},
      schemeNutrition: {},
      weekTap: 1,
      chuFshow: 1,
      foodInfo: [],
      sunData: [
        { name: '早餐', value: '红薯100g+无糖八宝粥（杂粮类）1碗+脱脂牛奶200ml+苹果100g ' },
        { name: '中餐', value: '糙米饭100g+清蒸鲳鱼100g+蒜蓉空心菜150g+冬瓜薏米汤1碗' },
        { name: '晚餐', value: '玉米饼1张（50g）+炖豆腐海带（豆腐50g）+炒西兰花150g ' },
        { name: '加餐', value: '原味杏仁10g+梨100g' }
      ],
      monData: [
        { name: '早餐', value: '燕麦片50g煮粥+水煮蛋清1个+脱脂牛奶200ml+苹果100g' },
        { name: '中餐', value: '糙米饭100g+清蒸鲈鱼80g+蒜蓉西兰花150g+凉拌黄瓜100g' },
        { name: '晚餐', value: '红薯100g+鸡胸肉炒彩椒（鸡胸50g，青椒红椒各50g）+清炒空心菜150g' },
        { name: '加餐', value: '原味杏仁10g+梨100g' }
      ],
      tueData: [
        { name: '早餐', value: '全麦面包2片+无糖豆浆200ml+煮鹌鹑蛋2个（只吃1个蛋黄）+圣女果100g' },
        { name: '中餐', value: '藜麦饭100g+红烧带鱼块80g+清炒菠菜150g（焯水）+冬瓜海带汤1碗  ' },
        { name: '晚餐', value: '玉米糁粥1碗+豆腐炖白菜（北豆腐50g，白菜150g）+蒸南瓜100g  ' },
        { name: '加餐', value: '低脂酸奶100g+蓝莓50g' }
      ],
      wedData: [
        { name: '早餐', value: '小米粥1碗+花卷1个（30g）+水煮蛋清1个+橙子100g  ' },
        { name: '中餐', value: '糙米饭100g+清蒸鸡腿（去皮）70g+蚝油生菜150g+番茄蛋汤（少油，蛋清为主）' },
        { name: '晚餐', value: '荞麦面（干重50g）+凉拌木耳黄瓜150g+蒸茄子80g+清蒸小黄鱼80g' },
        { name: '加餐', value: '核桃仁10g+梨100g' }
      ],
      thuData: [
        { name: '早餐', value: '玉米糊50g+全麦馒头1个+脱脂牛奶200ml+猕猴桃100g' },
        { name: '中餐', value: '红薯饭（红薯50g+大米50g+清蒸鳕鱼100g+清炒油麦菜150g+紫菜蛋花汤（少油）' },
        { name: '晚餐', value: '绿豆粥1碗+炖豆腐蘑菇（豆腐50g，香菇50g）+炒西葫150g' },
        { name: '加餐', value: '原味腰果10g+苹果100g' }
      ],
      friData: [
        { name: '早餐', value: '燕麦粥50g+煮鸡蛋1个（只吃蛋白）+无糖豆浆200ml+柚子100g' },
        { name: '中餐', value: '糙米饭100g+香煎三文鱼80g+清炒芥蓝150g+凉拌莴笋丝100g' },
        { name: '晚餐', value: '南瓜粥1碗+鸡丝拌芹菜（鸡胸50g，芹菜100g）+蒸胡萝卜80g ' },
        { name: '加餐', value: '低脂酸奶100g+草莓100g' }
      ],
      satData: [
        { name: '早餐', value: '杂粮粥1碗+花卷1个+水煮蛋清1个+香蕉半根（约50g）' },
        { name: '中餐', value: '全麦饺子（馅为瘦猪肉30g+白菜100g，皮用全麦粉）+清炒芦笋150g' },
        { name: '晚餐', value: '小米饭100g+清蒸虾80g+炒荷兰豆80g+凉拌黑木耳100g' },
        { name: '加餐', value: '核桃仁10g+橙子100g' }
      ]
    }
  },
  created() {
    this.getweek()
  },
  mounted() {
    this.onload()
  },
  methods: {
    onload() {
      const wxUserId = this.$route.query.wxUserId
      getUserJkDetail(wxUserId).then(res => {
        const wxUserId = window.localStorage.getItem('pcUserId');
        if (wxUserId === '2043870969731301377') {
          res.data.userJk.name = func.maskName(res.data.userJk.name);
          res.data.userJk.mobile = func.maskPhone(res.data.userJk.mobile);
        }
        this.info = res.data.userJk
      })
      getSchemeNutritionNew(wxUserId).then(res => {
        this.schemeNutrition = res.data
        const foodInfo = [
          { name: '早餐', value: this.schemeNutrition.schemeNutritionNew.sevenBreakfast },
          { name: '中餐', value: this.schemeNutrition.schemeNutritionNew.sevenLunch },
          { name: '晚餐', value: this.schemeNutrition.schemeNutritionNew.sevenDinner },
          { name: '加餐', value: this.schemeNutrition.schemeNutritionNew.sevenSnack }
        ]
        this.foodInfo = foodInfo
        this.weekTap = '日'
      })
    },
    getweek() {
      const days = ['日', '一', '二', '三', '四', '五', '六']
      const date = new Date()
      const dayOfWeek = days[date.getDay()]
      this.weekChange(dayOfWeek)
      console.log(dayOfWeek)
    },

    changeChuF(id) {
      this.chuFshow = id
    },

    weekChange(id) {
      this.weekTap = id
      // const that = this
      let foodInfo = []
      switch (id) {
        case '一':
          // that.foodInfo = that.monData
          foodInfo = [
            { name: '早餐', value: this.schemeNutrition.schemeNutritionNew.oneBreakfast },
            { name: '中餐', value: this.schemeNutrition.schemeNutritionNew.oneLunch },
            { name: '晚餐', value: this.schemeNutrition.schemeNutritionNew.oneDinner },
            { name: '加餐', value: this.schemeNutrition.schemeNutritionNew.oneSnack }
          ]
          this.foodInfo = foodInfo
          break
        case '二':
          foodInfo = [
            { name: '早餐', value: this.schemeNutrition.schemeNutritionNew.twoBreakfast },
            { name: '中餐', value: this.schemeNutrition.schemeNutritionNew.twoLunch },
            { name: '晚餐', value: this.schemeNutrition.schemeNutritionNew.twoDinner },
            { name: '加餐', value: this.schemeNutrition.schemeNutritionNew.twoSnack }
          ]
          this.foodInfo = foodInfo
          break
        case '三':
          foodInfo = [
            { name: '早餐', value: this.schemeNutrition.schemeNutritionNew.threeBreakfast },
            { name: '中餐', value: this.schemeNutrition.schemeNutritionNew.threeLunch },
            { name: '晚餐', value: this.schemeNutrition.schemeNutritionNew.threeDinner },
            { name: '加餐', value: this.schemeNutrition.schemeNutritionNew.threeSnack }
          ]
          this.foodInfo = foodInfo
          break
        case '四':
          foodInfo = [
            { name: '早餐', value: this.schemeNutrition.schemeNutritionNew.fourBreakfast },
            { name: '中餐', value: this.schemeNutrition.schemeNutritionNew.fourLunch },
            { name: '晚餐', value: this.schemeNutrition.schemeNutritionNew.fourDinner },
            { name: '加餐', value: this.schemeNutrition.schemeNutritionNew.fourSnack }
          ]
          this.foodInfo = foodInfo
          break
        case '五':
          foodInfo = [
            { name: '早餐', value: this.schemeNutrition.schemeNutritionNew.fiveBreakfast },
            { name: '中餐', value: this.schemeNutrition.schemeNutritionNew.fiveLunch },
            { name: '晚餐', value: this.schemeNutrition.schemeNutritionNew.fiveDinner },
            { name: '加餐', value: this.schemeNutrition.schemeNutritionNew.fiveSnack }
          ]
          this.foodInfo = foodInfo
          break
        case '六':
          foodInfo = [
            { name: '早餐', value: this.schemeNutrition.schemeNutritionNew.sixBreakfast },
            { name: '中餐', value: this.schemeNutrition.schemeNutritionNew.sixLunch },
            { name: '晚餐', value: this.schemeNutrition.schemeNutritionNew.sixDinner },
            { name: '加餐', value: this.schemeNutrition.schemeNutritionNew.sixSnack }
          ]
          this.foodInfo = foodInfo
          break
        case '日':
          foodInfo = [
            { name: '早餐', value: this.schemeNutrition.schemeNutritionNew.sevenBreakfast },
            { name: '中餐', value: this.schemeNutrition.schemeNutritionNew.sevenLunch },
            { name: '晚餐', value: this.schemeNutrition.schemeNutritionNew.sevenDinner },
            { name: '加餐', value: this.schemeNutrition.schemeNutritionNew.sevenSnack }
          ]
          this.foodInfo = foodInfo
          break
      }
    },

    click(index) {
      let path = ''
      switch (index) {
        case 0:
          path = '/agent/blood/archive'
          break
        case 1:
          path = '/agent/blood/nutritionalPlan'
          break
        case 2:
          path = '/agent/blood/bodyComposition'
          break
        case 3:
          path = '/agent/blood/exercisePlan'
          break
        case 4:
          path = '/agent/blood/behavioralTherapy'
          break
        case 5:
          path = '/agent/blood/sportsFollow'
          break
        case 6:
          path = '/agent/blood/drugRegimen'
          break
      }
      const parameter = {
        wxUserId: this.wxUserId
      }
      this.$router.push({
        path: path,
        query: parameter
      })
    },

    back() {
      // this.$router.go(-1);
      this.$router.push({
        path: '/agent/blood/blood'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.card-container {
  width: 100%;
  max-width: 100vw; /* 可根据需要调整最大宽度 */
  margin: 0 auto;
  padding: 0 1vw;
  box-sizing: border-box;
}
.card {
  display: flex;
}
.left {
  width: 20%;
}
.person {
  width: 100%;
  height: 50vh;
  background-color: #ffffff;
  border-radius: 12px;
  margin-top: 10px;
  .title {
    width: 100%;
    height: 26%;
    background-color: #409eff;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }
  .img {
    width: 40%;
    height: auto;
    margin: 0 auto;
    border-radius: 12px;
    margin-top: -25%;
    background-color: #ffffff;
    display: flex;
    justify-items: center;
    justify-content: center;
    padding: 4% 0;
    div {
      width: 80%;
      background-color: #409eff;
      border-radius: 12px;
      display: flex;
      justify-items: center;
      justify-content: center;
      padding: 18% 0;
      img {
        width: 50%;
        height: auto;
      }
    }
  }
  .name {
    width: 100%;
    text-align: center;
    font-size: 28px;
    color: #101010;
    font-weight: bold;
  }
  .body {
    padding: 5%;
    height: 50%;
    .th {
      display: flex;
      width: 95%;
      font-size: 16px;
      line-height: 40px;
      .td {
        width: 40%;
        // text-align: right;
      }
    }
  }
}
.plan {
  width: 100%;
  padding-bottom: 20px;
  // height: 46vh;
  background-color: #ffffff;
  border-radius: 12px;
  margin-top: 16px;
  border: 0.5px solid #bbb094;
  .title {
    height: 12%;
    background-color: #bbb094;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    display: flex;
    justify-items: center;
    padding: 4%;
    img {
      width: 30px;
      height: 30px;
    }
    div {
      line-height: 30px;
      color: #fff;
      font-size: 18px;
      margin-left: 10px;
    }
  }
  .body {
    padding: 4%;
    color: #b2a073;
    font-size: 14px;
    div {
      margin-top: 5px;
      line-height: 24px;
    }
  }
}
.right {
  width: 80%;
  padding: 10px 20px;
}
.chuF {
  width: 90%;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 2%;
  .title {
    display: flex;
    div {
      width: 12%;
      height: 40px;
      line-height: 40px;
      border: 1px solid #666666;
      text-align: center;
      color: #666666;
      border-radius: 24px;
      margin-right: 2%;
    }
    .active {
      background-color: #409eff;
      color: #fff;
      border: none;
    }
  }
  .content {
    width: 100%;
    .name {
      height: 45px;
      padding: 10px 0;
      display: flex;
      margin-top: 10px;
      .icon {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        margin: 5px 10px 0 0;
      }
      .h1 {
        background-color: #409eff;
      }
      .h2 {
        background-color: #fe62e7;
      }
      .h3 {
        background-color: #ff9037;
      }
      .h4 {
        background-color: #43d87f;
      }
      .h5 {
        background-color: #bb68fc;
      }
      .dt {
        color: #0f1021;
        font-size: 16px;
      }
    }
    .card {
      border-left: 1px solid #e6e6e6;
      padding: 0 20px;
      margin-left: 5px;
      color: #666666;
      font-size: 14px;
      line-height: 20px;
      min-height: 20px;
    }
  }
}
.week {
  width: 90%;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 2%;
  margin-top: 16px;
  display: flex;
  .side {
    font-size: 25px;
    background-color: red;
    width: 5%;
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
    writing-mode: vertical-lr; /* 从左到右的垂直文本 */
    letter-spacing: 8px;
    padding-left: 1%;
    text-align: center;
    background-color: #409eff;
    color: #fff;
  }
  .content {
    width: 95%;
    padding: 2% 4%;
    .title {
      width: 90%;
      margin-left: 5%;
      display: flex;
      justify-content: space-between;
      div {
        width: 5%;
        height: 50px;
        line-height: 50px;
        text-align: center;
        color: #aaa6c8;
        border-radius: 12px;
      }
      .active {
        background-color: #409eff;
        color: #fff;
      }
    }
    .tent {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      .food {
        width: 22%;
        padding: 16px 2%;
        border: 1px solid #aaa6c8;
        border-radius: 12px;
        background-color: #f0f8ff;
        color: #666666;
        font-size: 14px;
        line-height: 24px;
        div:first-child {
          width: 100%;
          text-align: center;
          font-size: 16px;
          margin-bottom: 5px;
        }
      }
    }
  }
}
.healthButton {
  /* background-color: #ebedf0; */
  color: black;
  border: 0px solid #c1c3c5;
  border-bottom: none;
  font-size: 15px;
  border-radius: 0px;
  margin-bottom: 2px;
}
.healthActive {
  border-bottom: 3px solid #409eff;
  color: #409eff;
  font-weight: bold;
}
</style>
